import { useState, useEffect, useMemo } from 'react';
import { dateUtils } from '../utils/dateUtils';

export const useNewsFilters = (news) => {
  const defaultFilters = {
    category: 'all',
    dateRange: 'all',
    order: 'desc', 
  };
  
  const [filters, setFilters] = useState(defaultFilters);
  const [filteredNews, setFilteredNews] = useState([]);
  
  // Extraer categorías únicas
  const categories = useMemo(() => 
    ['all', ...new Set(news.map(n => n.category).filter(Boolean))], 
    [news]
  );
  
  // Aplicar filtros cuando cambian los filtros o las noticias
  useEffect(() => {
    const applyFilters = () => {
      let result = news.filter(n => n.status === 'approved');
      
      // Filtro por categoría
      if (filters.category !== 'all') {
        result = result.filter(n => n.category === filters.category);
      }
      
      
      // Filtro por fecha
      if (filters.dateRange !== 'all') {
        result = result.filter(n => {
          const newsDate = n.creationDate;
          
          if (filters.dateRange === 'today') {
            return dateUtils.isToday(newsDate);
          }
          
          if (filters.dateRange === 'week') {
            return dateUtils.isWithinDays(newsDate, 7);
          }
          
          if (filters.dateRange === 'month') {
            return dateUtils.isWithinDays(newsDate, 30);
          }
          
          return true;
        });
      }
      
      // Ordenar
      result.sort((a, b) => {
        const dateA = dateUtils.normalizeDate(a.creationDate);
        const dateB = dateUtils.normalizeDate(b.creationDate);
        
        return filters.order === 'asc'
          ? dateA - dateB
          : dateB - dateA;
      });
      
      return result;
    };
    
    setFilteredNews(applyFilters());
  }, [news, filters]);
  
  return {
    filters,
    setFilters,
    filteredNews,
    categories,
    defaultFilters
  };
};